// extracted by mini-css-extract-plugin
module.exports = {"colors":"'../../css/colors.css'","darkOrange":"#D8630F","contact":"ContactPage_contact__2a0FQ"};